import React from "react";
import { bool, func, string } from "prop-types";
import caretUpImage from "resources/images/caret-up.png";
import caretDownImage from "resources/images/caret-down.png";

const ViewPreviewButton = ({
  setViewPreview,
  viewPreview,
  notificationType,
}) => (
  <button
    type="button"
    className="btn-as-link"
    style={{ color: "#425cc7" }}
    onClick={() => setViewPreview(!viewPreview)}
  >
    {`${notificationType} Preview`}
    <span>
      {viewPreview ? (
        <img
          src={caretUpImage}
          height="16px"
          width="16px"
          alt="hide preview"
          style={{ marginBottom: "2px" }}
        />
      ) : (
        <img
          src={caretDownImage}
          height="16px"
          width="16px"
          alt="show preview"
          style={{ marginBottom: "2px" }}
        />
      )}
    </span>
  </button>
);

ViewPreviewButton.propTypes = {
  setViewPreview: func,
  viewPreview: bool,
  notificationType: string,
};

export default ViewPreviewButton;
